import api from './client';
import ApiError from './error';

const InstitutionService = {
  async getAllInstitutions() {
    try {
      const client = await api.getClient();
      return client.searchInstitutions();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getInstitution({ id }) {
    try {
      const client = await api.getClient();
      return client.viewInstitution(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createInstitution({
    address, phoneNumber, email, website, googlePlaceId, options, translations,
  }) {
    const data = {};
    data.address = address;
    data.translations = translations;

    if (phoneNumber) {
      data.phoneNumber = phoneNumber;
    }

    if (email) {
      data.email = email;
    }

    if (website) {
      data.website = website;
    }

    if (googlePlaceId) {
      data.googlePlaceId = googlePlaceId;
    }

    if (options) {
      data.options = options;
    }

    try {
      const client = await api.getClient();
      return client.createInstitution(null, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updateInstitution({
    id, address, phoneNumber, email, website, googlePlaceId, options, translations,
  }) {
    const data = {};
    data.address = address;
    data.translations = translations;

    if (phoneNumber) {
      data.phoneNumber = phoneNumber;
    }

    if (email) {
      data.email = email;
    }

    if (website) {
      data.website = website;
    }

    if (googlePlaceId) {
      data.googlePlaceId = googlePlaceId;
    }

    if (options) {
      data.options = options;
    }

    try {
      const client = await api.getClient();
      return client.updateInstitution(id, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async deleteInstitution({ id }) {
    try {
      const client = await api.getClient();
      return client.deleteInstitution(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default InstitutionService;
